module.exports = __webpack_public_path__ + "9e65557aa9b3e08108513751cf161030.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/cello-s.png
// module id = 1869
// module chunks = 0